<span class="container">BETA</span>

<style>
  .container {
    border: solid rgba(116, 255, 241, 0.2) 1px;
    border-radius: 0.375rem;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    color: rgba(116, 255, 241, 0.9);
    font-weight: 600;
    font-size: 0.75rem;
    line-height: 1rem;
  }
</style>
